import {Button} from 'antd';

import {appRoute} from '../../../../../../app-route';
import {NavigationLink} from '../../../../../../layout/navigation-link/navigation-link';
import {Locale} from '../../../../../../provider/locale/locale';
import {EmptyTable} from '../../source-links-page/source-content/empty-table/empty-table';

export function FacebookNoAccountPlaceholder(): JSX.Element {
    return (
        <EmptyTable
            subtitle={<Locale stringKey="SOURCE_SETTINGS__FACEBOOK__NO_ACCOUNT__DESCRIPTION" />}
            title={<Locale stringKey="SOURCE_SETTINGS__FACEBOOK__NO_ACCOUNT__TITLE" />}
        >
            <NavigationLink to={appRoute.accountLinkingSettings.path}>
                <Button type="primary">
                    <Locale stringKey="SOURCE_SETTINGS__FACEBOOK__CONNECT_ACCOUNT" />
                </Button>
            </NavigationLink>
        </EmptyTable>
    );
}
